import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import './style.scss';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

const KCSModal = props => {
  const {
    isOpenModal,
    title,
    content,
    closeButton,
    closeModal,
    confirmButton,
    confirmAction,
    size,
    disabledConfirmBtn,
    customClass
  } = props;

  const intl = useIntl();

  return (
    <Modal show={isOpenModal} onHide={() => {closeModal(true)}} className="modal-wrapper" size={size}>
      <Modal.Header closeButton>
        <Modal.Title>{title || intl.formatMessage({ id: 'IDS_TV_NOTIFICATION' })}</Modal.Title>
      </Modal.Header>

      <Modal.Body className={`text-center ${customClass || ''}`}><h6>{content}</h6></Modal.Body>

      <Modal.Footer>
        {closeButton &&
          <Button onClick={() => closeModal(false)} className="close-btn">
            {closeButton === true ? intl.formatMessage({ id: 'IDS_VPLUS_OTP_CANCEL' }) : closeButton}
          </Button>
        }
        <Button onClick={confirmAction || closeModal} className="confirm-btn" disabled={disabledConfirmBtn}>
          {confirmButton || 'OK'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

KCSModal.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  closeModal: PropTypes.func.isRequired,
  confirmButton: PropTypes.string,
  confirmAction: PropTypes.func,
};

KCSModal.defaultProps = {
  isOpenModal: false,
  closeModal: () => { },
};

export default React.memo(KCSModal);
